#### Work arrangements in position profiles

A work arrangement can now be specified when posting and updating a job ad.

Three types of `seekWorkArrangementCodes` are supported: `Hybrid`, `OnSite`, and `Remote`. Only one item can be set.

SEEK will attempt to infer the appropriate work arrangement for hirers using existing integrations that do not support this field.
When you add the field to your job posting flow, present it to hirers as a mandatory field.

The following sample mutation is provided for demonstration purposes.

```graphql label="Mutation"
mutation ($input: PostPositionInput!) {
  postPosition(input: $input) {
    ... on PostPositionPayload_Success {
      positionOpening {
        documentId {
          value
        }
      }
      positionProfile {
        profileId {
          value
        }
      }
    }
  }
}
```

```json label="Variables"
{
  "input": {
    "positionOpening": {
      "postingRequester": {
        "roleCode": "Company",
        "id": "seekAnzPublicTest:organization:seek:93WyyF1h",
        "personContacts": [
          {
            "name": { "formattedName": "Mary Manager" },
            "roleCode": "HiringManager",
            "communication": {
              "email": [{ "address": "mary.manager@example.com" }],
              "phone": [{ "formattedNumber": "03 8517 4100" }]
            }
          }
        ]
      }
    },
    "positionProfile": {
      "positionTitle": "Associate Developer",
      "positionOrganizations": "seekAnzPublicTest:organization:seek:93WyyF1h",
      "positionFormattedDescriptions": [
        {
          "descriptionId": "SearchSummary",
          "content": "Start your software development career with a dynamic & growing team"
        },
        {
          "descriptionId": "AdvertisementDetails",
          "content": "A newly created role for an ambitious <b>junior</b> or <b>graduate</b> developer. Be part of a great team in the Bendigo area."
        }
      ],
      "offeredRemunerationPackage": {
        "basisCode": "Hourly",
        "ranges": {
          "minimumAmount": {
            "value": 70,
            "currency": "AUD"
          },
          "maximumAmount": {
            "value": 85,
            "currency": "AUD"
          },
          "intervalCode": "Hour"
        },
        "descriptions": []
      },

      "seekAnzWorkTypeCode": "PartTime",
      "seekWorkArrangementCodes": ["Hybrid"],

      "jobCategories": "seekAnzPublicTest:jobCategory:seek:2EFstqFvP",
      "positionLocation": "seekAnzPublicTest:location:seek:QVS62e6K",
      "postingInstructions": {
        "seekAdvertisementProductId": "globalPublicTest:adProduct:seekApi:EWHKTY9D6mJFiA5EH6P7MFbCR3cKV9WdNSMC6e1vqiUJ",
        "idempotencyId": "6eaeb58c-cc38-4b0e-8353-daa3011f1ece"
      }
    }
  }
}
```
